import {
  POWER_CONSUMER_BILLING_INCHARGE,
  POWER_CONSUMER_BILLING_OPERATOR,
  SUPER_ADMIN,
  powerAdmin1Roles,
  powerAdmin2Roles,
} from "common/constant";
import { isAuthorizedUser } from "./isAuthorizedUser";
import { getOptionValue } from "common/enums";

const DEFAULT_STATUS = "Default";

const canApproveAndRevoke = {
  canApprove: true,
  canRevoke: true,
};

export const getBillingApprovalStatus = (
  { approvedBy, revokedBy, status },
  userRoles
) => {
  if (
    status &&
    status !== getOptionValue("billCalculationStatus", DEFAULT_STATUS)
  ) {
    return {
      canApprove: false,
      canRevoke: false,
    };
  }

  if (
    userRoles.includes(SUPER_ADMIN) ||
    isAuthorizedUser(userRoles, [...powerAdmin2Roles, ...powerAdmin1Roles])
  ) {
    return {
      canApprove: false,
      canRevoke: false,
    };
  }

  if (
    isAuthorizedUser(userRoles, [POWER_CONSUMER_BILLING_INCHARGE]) &&
    [POWER_CONSUMER_BILLING_OPERATOR].includes(approvedBy) &&
    !revokedBy
  ) {
    return canApproveAndRevoke;
  }

  if (
    isAuthorizedUser(userRoles, [POWER_CONSUMER_BILLING_OPERATOR]) &&
    ((!approvedBy && !revokedBy) ||
      [POWER_CONSUMER_BILLING_INCHARGE].includes(revokedBy))
  ) {
    return { canApprove: true, canRevoke: false };
  }

  return { canApprove: false, canRevoke: false };
};
